import { render, staticRenderFns } from "./cusSettlement.vue?vue&type=template&id=272edaaa&scoped=true&"
import script from "./cusSettlement.vue?vue&type=script&lang=js&"
export * from "./cusSettlement.vue?vue&type=script&lang=js&"
import style0 from "./cusSettlement.vue?vue&type=style&index=0&id=272edaaa&lang=less&scoped=true&"
import style1 from "./cusSettlement.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272edaaa",
  null
  
)

component.options.__file = "cusSettlement.vue"
export default component.exports